import Link from "next/link";
import React, { useEffect, useState } from "react";
import Image from 'next/image'
// import img from '../Images/logo.jpg'
import { useRouter } from "next/router";
import 'react-toastify/dist/ReactToastify.css';
import { FaShoppingCart, FaHeart, FaUser, FaSignOutAlt, FaBell } from "react-icons/fa";
import api from '@api/Apis'
import NavBarStyle from "./NavBarStyle";
import classNames from 'classnames';
import NotFication, { WishListNotFication, LogoutNav, MenuDropDownPop } from "./NotFicationLogout";
import TemporaryDrawer from "./Drawer";
import { isLoginCheck, LinkAnchor, refferalRouting } from "@Components/Common/CommonMethods";
import _ from "lodash";

const NavBar = props => {
    const { profileData } = props;

    const router = useRouter();
    const DATA = profileData?.user_data?.userdetails?.[0]?.test_report_release;


    const [AddClass, setAddClass] = useState(false);
    const [menuData, setMenuData] = useState(
        [
            // {
            //     "id": 3,
            //     "data": [],
            //     "menu_number": 2,
            //     "title": "Wellness Professionals",
            //     "url": "/wellness_professionals",
            //     "check": false,
            //     "currentUrl": router?.asPath?.includes('/wellness_professionals')
            // },
            // {
            //     "id": 4,
            //     "data": [],
            //     "menu_number": 30,
            //     "title": "Retailers",
            //     "url": "/retailers",
            //     "check": false,
            //     "currentUrl": router?.asPath?.includes('/retailers')
            // },
            // {
            //     "id": 33,
            //     "data": null,
            //     "menu_number": 35,
            //     "title": "Employers",
            //     "url": "/employers",
            //     "check": false,
            //     "currentUrl": router?.asPath?.includes('/employers')
            // }
        ]);

    const newUrl = {
        "id": 1,
        "data": [],
        "menu_number": 2,
        "title": "Individual",
        "url": "/",
        "check": false,
        "currentUrl": false
    }
    const [token, setToken] = useState('')
    const [isActiveMobile, setIsActiveMobile] = useState("");
    const [searchData, setSearchData] = useState()
    const store = (router?.query?.page) ? router?.query?.page : 'us';

    useEffect(() => {
        _menuSectionFunction();
    }, [])

    const _menuSectionFunction = async () => { }
    const showlogin = () => {
        setAddClass(false);
        props.setoldpath(router.asPath)
        const url = refferalRouting(`/us/login`);
        router.push(url)
    }
    const [countryState, setCountryState] = useState({ popUp: false, value: "USA" });
    const [languageState, setLanguageState] = useState({ popUp: false, value: "ENG" });

    const toggleDrawer = (section, value) => {
        if (section === "Country") {
            setCountryState({ ...countryState, popUp: true });
            return;
        }
        setLanguageState({ ...languageState, popUp: true });
    };

    function _setValues(section, value) {
        if (section === "Country") {
            setCountryState({ value: value, popUp: false });
            return;
        }
        setLanguageState({ value: value, popUp: false });
    }
    // function handleGetStarted() {
    //     router.push('/us/signup?d=is_affiliate')
    // }

    return (
        <>
            <NavBarStyle>
                <div className="header-section">
                    <div className="container">

                        <nav className="navbar navbar-default">
                            <div className="navbar-header">
                                {AddClass ?
                                    <button type="button" className="close" data-toggle="collapse" onClick={() => setAddClass(false)}><i className="fa fa-times" aria-hidden="true"></i></button>
                                    :
                                    <button type="button" className="navbar-toggle collapsed " data-toggle="collapse" data-target="#navbar-collapse-1" onClick={() => setAddClass(true)}>
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </button>
                                }
                                <LinkAnchor href={refferalRouting("/")}><img src="/images/logo_snip.png" /></LinkAnchor>
                            </div>
                            <div className={classNames("collapse navbar-collapse ", { 'open_collapse_nav': AddClass, "hide": !AddClass })} id="navbar-collapse-1">
                                <ul className={`nav navbar-nav navbar-left`}>
                                    {
                                        menuData?.map(({ title, data, url, check, currentUrl }, index) => (
                                            <div key={index + 1}>
                                                {!currentUrl
                                                    ?
                                                    <MenuDropDownPop
                                                        title={title}
                                                        url={url}
                                                        innerData={data}

                                                        check={check}
                                                        setAddClass={setAddClass}
                                                        setIsActive={setIsActiveMobile}
                                                        isActive={isActiveMobile} />
                                                    :

                                                    <MenuDropDownPop
                                                        title={newUrl?.title}
                                                        url={newUrl?.url}
                                                        innerData={newUrl?.data}
                                                        check={newUrl?.check}
                                                        setAddClass={setAddClass}
                                                        setIsActive={setIsActiveMobile}
                                                        isActive={isActiveMobile} />
                                                }
                                            </div>
                                        ))

                                    }
                                    <li><a href="https://blog.snipnutrition.com/" target="_blank">Blog</a></li>
                                    <li onClick={() => setAddClass(false)}><LinkAnchor href={refferalRouting("/us/about_us")}>About Us</LinkAnchor></li>
                                    {!DATA &&
                                        <li onClick={() => setAddClass(false)}><LinkAnchor href={refferalRouting("/dna-data-entry")}>DNA Data Entry</LinkAnchor></li>
                                    }
                                    <li onClick={() => setAddClass(false)}><LinkAnchor href={refferalRouting("/get_started")}><button>Get Your DNA Test Kit
                                    </button></LinkAnchor>
                                    </li>
                                </ul>
                                <div className="upper_lower_div">
                                    { /*<div className="broughtby">
                                        {props?.subDomain &&
                                            <span>Brought to you By: {props?.subDomain}</span>}
                                        </div>*/}

                                    <ul className="nav navbar-nav navbar-right" onClick={() => { props?.updatecartdata(true) }}>

                                        <li>
                                            <div className="login_signin" onClick={() => { setAddClass(false), localStorage.removeItem("consentForm"), localStorage.removeItem("consentFormCheckout") }}>
                                                <LinkAnchor href={refferalRouting("/us/kit_form")} className="font_change">Register Kit</LinkAnchor>
                                            </div>
                                        </li>

                                        <li>
                                            <>
                                                {(isLoginCheck()) ?
                                                    <>
                                                        <div className="dashboard_div">
                                                            <Link className="nav-link" exact="true" href={refferalRouting(`/${store}/user/dashboard`)}>
                                                                <a onClick={() => setAddClass(false)}>
                                                                    <div className="account_title font_change">My Account</div>
                                                                    <div className="account_icon font_change"><FaUser />
                                                                    </div>
                                                                </a>
                                                            </Link>
                                                            <LogoutNav store={store} section="from_navBar_section" key="NavbarSection3" token={token} {...props} />
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="login_signin" onClick={() => setAddClass(false)}>
                                                        <LinkAnchor href={refferalRouting(`/${store}/login`)} className="font_change">Login</LinkAnchor>
                                                    </div>
                                                }
                                            </>
                                        </li>
                                        {/* {!(isLoginCheck()) &&
                                            <li>
                                                <div className="login_signin" onClick={() => setAddClass(false)}>
                                                    <a href={refferalRouting("/us/get_started")} className="font_change">Get Your DNA Test Kit

                                                    </a>
                                                </div>
                                            </li>} */}

                                        {/* view Cart with pop up html */}
                                        <li className="view_cart_section" onClick={() => setAddClass(false)}>
                                            <Link className="" exact="true" href={refferalRouting(`/${store}/cart/viewCart`)}>
                                                <div className="dashboard_div">
                                                    <a>
                                                        <div className="cart_title font_change" style={{
                                                            cursor: 'pointer'
                                                        }}>
                                                            View Cart
                                                        </div>
                                                        <div className="icon-box-cart">
                                                            <FaShoppingCart />
                                                            {props?.cartdata?.products?.length > 0 && props?.counts &&
                                                                <span>{props?.counts ? props?.counts : 0}</span>
                                                            }
                                                        </div>
                                                    </a>
                                                </div>
                                            </Link>

                                            {/* <ul className="dropdown-popup_viewCart">
                                                {(props?.cartdata?.products?.length > 0)
                                                    ?
                                                    <>
                                                        {props?.cartdata?.products?.map((productdata, index) => {
                                                            return (
                                                                <li className="" key={index + 1} >
                                                                    <div className="view_cart_div">
                                                                        {productdata?.product?.product_images[0]?.image
                                                                            ?
                                                                            <img src={`${process.env.API_URL}${productdata.product?.product_images[0]?.image}`} />
                                                                            :
                                                                            <img src="/images/no-image.jpg" />
                                                                        }
                                                                    </div>
                                                                    <div className="txt" >
                                                                        {
                                                                            <>
                                                                                {productdata?.product.name} <br />
                                                                                Qty:{productdata?.quantity} <br />

                                                                                <NumberFormatComp
                                                                                    value={parseFloat(props?.cartdata?.is_autoship_user === 'True' ?
                                                                                        productdata?.product?.autoship_cost_price * productdata?.quantity
                                                                                        :
                                                                                        productdata?.product?.cost_price * productdata?.quantity).toFixed(2)} />
                                                                            </>
                                                                        }
                                                                    </div>
                                                                </li>
                                                            )
                                                        })}
                                                        <div className="view_cart_action"onClick={() => setAddClass(false)}>
                                                            <Button onClick={() => router.push(`/${store}/cart/viewCart`)}>View Cart</Button>
                                                        </div>
                                                    </>
                                                    :
                                                    <p className="cart_empty">Cart is empty</p>
                                                }
                                            </ul> */}
                                        </li>
                                        {(isLoginCheck()) &&
                                            <li className="logout_mobile">
                                                <div className="dashboard_div" onClick={props.handleLogout} style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '7px'
                                                }}>
                                                    <a onClick={() => console.log('')}>Logout</a>
                                                    <FaSignOutAlt style={{
                                                        fontSize: '20px',
                                                        color: ' #5fb6bd'
                                                    }} />
                                                </div>
                                            </li>
                                        }
                                        {/* <NotFication store={store} section="from_navBar_section" {...props} key="NavbarSection1" /> */}
                                        {/* <WishListNotFication store={store} section="from_navBar_section" {...props} key="NavbarSection2" /> */}
                                    </ul>
                                    {/* <div className="d-flex">
                                        <div>
                                            <input type="text" defaultValue="" onChange={(e) => console.log(e)} />
                                        </div>
                                        <div>
                                            <button>Search</button></div>
                                    </div> */}
                                </div>
                            </div >
                        </nav >
                    </div>
                </div>
            </NavBarStyle >
            <TemporaryDrawer state={countryState?.popUp}
                getData={(section, value) => _setValues(section, value)}
                toggleDrawer={() => setCountryState({ ...countryState, popUp: false })}
                data={['USA', 'Canada', 'Australia', ' New Zealand']} section="Country" />

            <TemporaryDrawer state={languageState?.popUp}
                getData={(section, value) => _setValues(section, value)}
                toggleDrawer={() => setLanguageState({ ...languageState, popUp: false })}
                data={['English']} section="Language" />
        </>


    );
}
export default NavBar;